import { TFunction } from 'i18next';
import _without from 'lodash/without';
import { InterventionAction } from 'graphql-common';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';

type Args = {
  onEdit?: () => void;
  onDelete?: () => void;
  t: TFunction<'translation', undefined>;
};

export default function getInterventionActionActionsMenu({
  onEdit,
  onDelete,
  t,
}: Args) {
  return _without(
    [
      onEdit
        ? {
            id: 'edit-action',
            title: t('edit'),
            onClick: () => onEdit(),
            leftIcon: Icons.edit,
            type: NavItemTypeEnum.Secondary,
          }
        : undefined,
      onDelete
        ? {
            id: 'delete-action',
            title: t('delete'),
            onClick: () => onDelete(),
            leftIcon: Icons.delete,
            type: NavItemTypeEnum.Secondary,
          }
        : undefined,
    ],
    undefined,
  ) as NavItem<InterventionAction>[];
}
